<template>
    <div class="d-flex flex-row">
        <DefaultEditorButtonPaneComponent 
            :context="context" ref="defaultEditorButtonPane"
        >
            <template v-slot:append>
                <v-btn ref="newAppointButton"
                    color="success"  class="mr-1 left-round"
                    :dark="false"
                    :disabled="newAppointButtonDisabled()"
                    @click="newAppointButtonClicked">
                    <v-icon>mdi-file-outline</v-icon>
                    <span>新建任职</span>            
                </v-btn>

                <v-btn ref="restoreAppointButton"
                    color="pink" class="mr-1"
                    :dark="false"
                    :disabled="restoreAppointButtonDisabled()"
                    @click="restoreAppointButtonClicked">
                    <v-icon>mdi-file-restore</v-icon>
                    <span>恢复任职</span>            
                </v-btn>

                <v-btn ref="stopAppointButton"
                    color="pink" class="mr-1 right-round"
                    :dark="false"
                    :disabled="stopAppointButtonDisabled()"
                    @click="stopAppointButtonClicked">
                    <v-icon>mdi-stop-circle-outline</v-icon>
                    <span>停止任职</span>            
                </v-btn>
            </template>
             
        </DefaultEditorButtonPaneComponent>

        
        
    </div>
</template>

<script>

    import DefaultEditorButtonPaneComponent from '../../../base/bill/EditorButtonPane.vue';
    

    export default {

        name:'UserEditorButtonPane',
        props:['context'],
        components:{
            'DefaultEditorButtonPaneComponent':DefaultEditorButtonPaneComponent,
        },
        data () {
            return {
            };
        },
        methods:{
            getContext(){
                return this.context;
            },
            getSignals () {
                return this.context.signals;
            },
            getModeHelper(){
                return this.context.modeHelper;
            },

            getEditorPane(){
                return this.context.bill.getEditorPane();
            },
            getEditor(){
                let editorPane = this.getEditorPane();
                if(editorPane && editorPane.getEditor)
                    return editorPane.getEditor();
                return null;
            },

            getEditorSelectedAppoint(){
                let editor = this.getEditor();
                if((!editor)||(!editor.getSelectedAppoints))
                    return null;
                let appoints = editor.getSelectedAppoints();
                if(!appoints || !appoints.length || appoints.length<1)    
                    return null;
                return appoints[0];    
            },

            getDefaultEditorButtonPane(){
                return this.$refs.defaultEditorButtonPane;
            },

            initComponent(){},
            initSignals(){
                let signal = this.getSignals().editCancelAsked;
                signal.dispatch();
            },

            newAppointButtonClicked(){
                let me = this;
                let editor = this.getEditor();
                if(!editor)
                    return null;
                let signal = this.getSignals().customCommandAsked;
                signal.dispatch({command:"INSERT_APPOINT",options:{callback:me.insertAppointCallback}});    
            },
            insertAppointCallback(){

            },
            restoreAppointButtonClicked(){
                console.log('restore appoint clicked');
                let appoint = this.getEditorSelectedAppoint();
                if(!appoint){
                    console.log("editor selected appoint is null when restore appoint ");
                    return;
                }
                let signal = this.getSignals().customCommandAsked;
                signal.dispatch({command:"RESTORE_APPOINT",appoint:appoint});
            },
            stopAppointButtonClicked(){
                console.log('stop appoint clicked');
                let appoint = this.getEditorSelectedAppoint();
                if(!appoint){
                    console.log("editor selected appoint is null when stop appoint ");
                    return;
                }
                let signal = this.getSignals().customCommandAsked;
                signal.dispatch({command:"STOP_APPOINT",appoint:appoint});
            },
            getButtonTextPermited(text){
                let billSupportedActions = this.getModeHelper().billSupportedAction;
                for(var idx in billSupportedActions){
                    let action = billSupportedActions[idx];
                    if(action.name == text)
                        return true;
                }
                return false;
            },
            getNewAppointButtonPermited(){
                return this.getButtonTextPermited('新建任职');
            },
            getRestoreAppointButtonPermited(){
                return this.getButtonTextPermited('恢复任职');
            },
            getStopAppointButtonPermited(){
                return this.getButtonTextPermited('停止任职');
            },
            
            //editorCan

            newAppointButtonDisabled(){
                let editor = this.getEditor();
                /*
                console.log("newAppointButtonDisabled");
                console.log(this.getNewAppointButtonPermited());
                console.log(this.getEditorPane().isBrowsing());
                console.log(this.getEditorPane().isEmptyData());
                */
                return (!this.getNewAppointButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (this.getEditorPane().isEmptyData());
            },

            stopAppointButtonDisabled(){
                let appoint = this.getEditorSelectedAppoint();
                /*
                console.log("stopAppointButtonDisabled");
                console.log(appoint);
                console.log(this.getStopAppointButtonPermited());
                console.log(this.getEditorPane().isBrowsing());
                */
                return (!this.getStopAppointButtonPermited()) 
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!appoint)
                ||(appoint.positionStatus!=1);
            },
 
            restoreAppointButtonDisabled(){
                let appoint = this.getEditorSelectedAppoint();
                /*
                console.log("restoreAppointButtonDisabled");
                console.log(appoint);
                console.log(this.getRestoreAppointButtonPermited());
                console.log(this.getEditorPane().isBrowsing());
                */
                return (!this.getRestoreAppointButtonPermited()) 
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())|| (!appoint)
                ||(appoint.positionStatus!=0);
            },
        },
        computed:{
            
        },
        created () {
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
    }

</script>

<style scoped>
</style>
